import ManageSubscriptionPage from "./component";

export default ManageSubscriptionPage;